module.exports = __webpack_public_path__ + "static/bannerVideo-03abdd2cdc149de2d72c5a5b2ea029c8.ogv";